import { Descriptor } from "@nens/rana/api-v1";

import { CompleteFile, Folder, Layer } from "@/features/publications";
import { PublicationMap } from "@/features/publications";

// Need to fix later. `layer.filePath` can be undefined, because it is still `layer.file_path`
function getLayerFilePath(layer: Layer): string | undefined {
  return layer.filePath ?? (layer as unknown as { file_path?: string }).file_path;
}

// Need to fix later. `layer.layerInFile` can be undefined, because it is still `layer.layer_in_file`
function getLayerInFile(layer: Layer): string | null | undefined {
  return layer.layerInFile ?? (layer as unknown as { layer_in_file?: string | null }).layer_in_file;
}

const getLayersFromLayerOrFolder = (layerOrFolder: Layer | Folder): Layer[] => {
  if (layerOrFolder.type === "folder") {
    return layerOrFolder.layers.flatMap(getLayersFromLayerOrFolder);
  } else {
    return [layerOrFolder];
  }
};

export function hasFileVersionMissingLayers(
  selectedFileDescriptor: Partial<Descriptor> | null | undefined,
  fileReference: CompleteFile,
  publicationMaps: PublicationMap[]
) {
  // If no descriptor or no layers, can't validate
  if (!selectedFileDescriptor?.layers || selectedFileDescriptor.layers.length === 0) {
    return false;
  }

  const allLayersInPublication: Layer[] = publicationMaps.flatMap((map) =>
    map.layers.flatMap(getLayersFromLayerOrFolder)
  );

  // Filter on layers connected to the file
  const layersUsingThisFile = allLayersInPublication.filter(
    (layer) => getLayerFilePath(layer) === fileReference.path
  );

  // Check only needed for TypeScript, since Descriptor.layers is not strictly defined
  const selectedVersionLayerIds = (selectedFileDescriptor.layers ?? [])
    .map((layer) => layer.id)
    .filter((id): id is string => typeof id === "string");

  // Check if chosen file version does not contain all layers belonging to the file version used in the publication
  const hasInvalidLayers = layersUsingThisFile.some((layer) => {
    // No problems for layers that represent a single file
    const layerInFile = getLayerInFile(layer);
    if (!layerInFile) return false;

    return !selectedVersionLayerIds.includes(layerInFile);
  });

  return hasInvalidLayers;
}
